module.exports = __webpack_public_path__ + "static/media/facebook_comment4.05541fd6.png";